import { FC, useCallback } from 'react';
import { CommonModal } from '../CommonModal';
import commonModalClass from '../../assets/scss/CommonModal.module.scss';
import { BottomButton } from '../ModalItem/BottomButton';
import { ConfirmModalViewType } from '../../types/view/ConfirmModalViewType';
import confirmModalClass from '../../assets/scss/ConfirmModal/ConfirmModal.module.scss';

export const ConfirmModal: FC<{
  active: boolean;
  closeFunc: () => void;
  confirmModal: ConfirmModalViewType | null;
}> = ({ active, closeFunc, confirmModal }) => {
  const onClickHandler = useCallback(() => {
    confirmModal?.onClickFunc();
    closeFunc();
  }, [confirmModal, closeFunc]);

  if (!confirmModal) return <></>;

  const content = (
    <>
      <div
        className={confirmModalClass.messageContainer}
        style={{ lineHeight: '24px' }}
      >
        {confirmModal.message.split(/\n/).map((text, index) =>
          /<b>(.*?)<\/b>/.test(text) ? (
            <span key={index}>
              {text
                .split(/<b>(.*?)<\/b>/)
                .map((part, i) => (i % 2 === 1 ? <b key={i}>{part}</b> : part))}
              <br />
            </span>
          ) : (
            <>
              {text}
              <br />
            </>
          )
        )}
      </div>
      <div
        className={commonModalClass.btnContainer}
        style={{ marginBottom: '40px' }}
      >
        <button
          className={commonModalClass.btnSecondary}
          onClick={onClickHandler}
        >
          {confirmModal.btnTitle}
        </button>
        <BottomButton
          buttonTitle="キャンセル"
          clickFunc={closeFunc}
        />
      </div>
    </>
  );

  return (
    <CommonModal
      active={active}
      closeFunc={closeFunc}
    >
      {content}
    </CommonModal>
  );
};
